import api from "../../../services/api";

export interface WhiteLabelSetupInfo {
  opticianName: string;
  name: string;
  primaryColor: string;
  logoUrl: string | null;
  completed: boolean;
}

export const fetchSetupInfo = async (token: string): Promise<WhiteLabelSetupInfo> => {
  const { data } = await api.get(`/white-label-setup/${token}`);
  return data;
};

export const uploadSetupLogo = async (token: string, file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("logo", file);
  const { data } = await api.post(`/white-label-setup/${token}/logo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.logo as string;
};

export const saveSetup = async (
  token: string,
  body: { name: string; primaryColor: string }
): Promise<void> => {
  await api.post(`/white-label-setup/${token}`, body);
};
